export namespace PIAModel{
    export interface Model{
        messages:Message[];
        documentData:DocumentData;
    }

    export interface Message{
        text:string;
        type: 'prompt' | 'completion';
    }

    export interface DocumentData{
        type:string;
        name:string;
        typeGuid:string;
    }
}